<div class="row border-bottom question-container" [ngClass]="{'border border-primary': isSelected}">
    <div class="col-8 form-group m-0 pl-0 border-right d-flex flex-row">
        <div class="d-flex flex-column pt-2 text-center">
            <span class="mb-2" style="width: 40px;">#{{Position + 1}}</span>
            <i class="pi pi-bars text-less-muted"></i>
        </div>
        
        <div class="d-flex flex-column flex-fill">
            <textarea class=" p-2 m-2 form-control" rows="2" maxlength="250" placeholder="{{'PH.PH_NEW_QUESTION' | translate}}" [(ngModel)]="Model.QuestionDesc"></textarea>
            <div class="form-check ml-2 mb-2">
                <input type="checkbox" [(ngModel)]="Model.IsAnswerRequired" class="form-check-input" id="question-required-{{Position}}">
                <label class="form-check-label" for="question-required-{{Position}}" translate>LBL.MANDATORY</label>
            </div>
        </div>
        
    </div>
    <div class="align-self-center col-4 answer-option-container"  (click)="openResponseConfiguration()">
        <button class="m-2 btn btn-link" *ngIf="!(Model?.AnswerOption)" translate>BTN.BTN_CONFIGURE_RESPONSE</button>
        <QuestionResponseView [Model]="Model.AnswerOption"></QuestionResponseView>
    </div>
    
    <div class="right-actions" [hidden]="!isSelected">
        <button type="button" [disabled]="AddDisabled" class="btn btn-secondary btn-circle mr-2" (click)="didTapActionButton('insert')">
            <i class="pi pi-plus"></i>
        </button>
        <button *ngIf="Position" type="button" class="btn btn-danger btn-circle" (click)="didTapActionButton('delete')">
            <i class="pi pi-trash"></i>
        </button>
    </div>
</div>
